// assets/js/composables/useTranslation.js

const checkWarn = typeof window.translations?.labels === 'object'
let showWarn = true

export function useTranslation() {
    const translate = (string) => {
        const translations = window.translations?.labels ?? window.translations ?? {}

        if (checkWarn && showWarn && string in (window.translations?.labels ?? {})) {
            console.warn('Las etiquetas deben ir solo en window.translations y NO en window.translations.labels')
            showWarn = false
        }

        return translations[string] ?? string
    }

    const getCurrentLanguage = () => {
        const lang = window.translations?.currentLanguage
        return lang || 'en'
    }

    return {
        translate,
        getCurrentLanguage
    }
}
